import React, { useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import { ListingNewsNode, PaginaNode, useListingNewsLazyQuery } from '@gql/graphql'
import BlogTemplate from '@components/templates/BlogTemplate/BlogTemplate'
import useTrans from '@hooks/useTrans'

interface BlogListingProps {
  pagina: PaginaNode
  listing: ListingNewsNode
  buttonUrl?: boolean
}

const BlogListing = ({ pagina, listing, buttonUrl = false }: BlogListingProps) => {
  const router = useRouter()
  const [page, setPage] = useState(listing.paginator.currentPage)
  const [articoli, setArticoli] = useState(listing.news)
  const [listingNewsQuery, { loading: loadingNews }] = useListingNewsLazyQuery({
    fetchPolicy: 'cache-first',
  })

  const nextPageLength = listing?.paginator?.itemsPerPage
  const categoria = 'categoria' in listing ? listing.categoria : undefined
  const categorie = 'categorie' in listing ? listing?.categorie : undefined
  const t = useTrans()

  const powerBarItems = categorie
    ? [
        {
          pk: 0,
          name: t('Tutti gli articoli'),
          selected: !categoria,
          url: listing?.root?.url || '/news',
        },
      ].concat(
        categorie.map((x) => ({
          pk: x.pk,
          name: x.nome,
          selected: categoria?.slug === x.slug,
          url: x.url,
        })) ?? []
      )
    : []

  const fetchListing = async () => {
    if ('categoria' in listing) {
      const { data } = await listingNewsQuery({
        variables: {
          slug: categoria?.slug,
          params: { p: page },
        },
      })

      if (data?.listingNews?.news) {
        listing.paginator = data?.listingNews?.paginator
        setArticoli([...articoli, ...data.listingNews.news])
      }
    }
  }

  useEffect(() => {
    if (page === listing.paginator.currentPage) return
    fetchListing()
  }, [page])

  const handleMore = (event) => {
    event.preventDefault()
    router.replace(`${router.asPath.split('?')[0]}?page=${page + 1}`, undefined, {
      shallow: true,
      scroll: false,
    })
    setPage(page + 1)
  }

  const linkNextPage = listing?.paginator?.pages[listing?.paginator?.currentPage]?.href

  return (
    <BlogTemplate
      key={'categoria' in listing ? listing?.categoria?.pk : undefined}
      pagina={pagina}
      articoli={articoli}
      powerBarItems={powerBarItems}
      handleMore={handleMore}
      loading={loadingNews}
      nextPageLength={nextPageLength}
      linkNextPage={linkNextPage}
      buttonUrl={buttonUrl}
    />
  )
}

export default BlogListing
